import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminEditStatePage = React.lazy(() => import(/* webpackChunkName: "AdminEditState" */ './Page'));
export const AdminEditState = () => (React.createElement(Page, { title: "Administrator Edit State" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminEditStatePage, null)))));
